module.exports = __webpack_public_path__ + "static/media/finishLive.c67c108d.svg";